import React from 'react';
import Relay from 'react-relay';

import RelayStore from '../../RelayStore'
import VenuePanel from '../../components/VenuePanel'


class EditVenue extends React.Component {

  constructor(props) {
    super(props);
  }

  refetchData = (callback) => 
    this.props.relay.forceFetch(null, state => {
      if (state.done && state.ready)
        callback()
    })

  render() {

    const { viewer, router } = this.props;
    const { venue } = viewer;
    if (!venue) return (<div>loading venue...</div>)

    return (
      <div className="panel" style={{marginTop:20}}>
		    {this.props.viewer && this.props.viewer.venue &&
          <VenuePanel
            viewer={this.props.viewer}
            venue={venue}
            refetchData={this.refetchData}
          />
        }
      </div>
    );
  }

}

export default Relay.createContainer(EditVenue, {
  initialVariables: {
    venueId: null,
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        venue (id: $venueId) {
          ${VenuePanel.getFragment('venue')}
        }
      }
      `,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Venue/EditVenue.js